console.log('%cWebsite Made by %cOneDoBit%c https://nedobitkov.com', 
  'color: #FFF; background-color: #111; font-size: 16px;', // Style for "Made by"
  'color: #fb9389; background-color: #111; font-size: 16px; font-weight: bold;', // Style for "OneDoBit"
  'color: red; font-size: 16px; background-color: #111;' // Style for the URL
);
setTimeout(() => {
  console.log('%cWebsite Made by %cOneDoBit%c https://nedobitkov.com', 
    'color: #FFF; background-color: #111; font-size: 16px;', // Style for "Made by"
    'color: #fb9389; background-color: #111; font-size: 16px; font-weight: bold;', // Style for "OneDoBit"
    'color: red; font-size: 16px; background-color: #111;' // Style for the URL
  );
}, 10000)

// Quick Add
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-product-form').forEach(form => {
    const selector = form.querySelector('[data-selected-variant-selector]')
    const select = form.querySelector('select[name="id"]')
    const titleDisplay = form.querySelector('[data-selected-variant-title]')
    const canPriceDisplay = form.querySelector('[data-selected-variant-can-price]')
    const priceDisplay = form.querySelector('[data-selected-variant-price]')

    // Click on visual selector opens native dropdown
    selector.addEventListener('click', () => {
      select.focus()
      select.click()
    })

    // Update display when variant changes
    select.addEventListener('change', () => {
      const selected = select.options[select.selectedIndex]

      titleDisplay.textContent = selected.dataset.canTitle || ''
      canPriceDisplay.textContent = `${selected.dataset.canPrice || ''} / can`
      priceDisplay.textContent = selected.dataset.price || ''
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-product-form').forEach(form => {
    const submitButton = form.querySelector('.add-to-cart-button')
    const cart = document.querySelector('cart-notification');

    form.addEventListener('submit', evt => {
      evt.preventDefault()

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(form)
      config.body = formData

      fetch(window.routes.cart_add_url, config)
        .then(res => res.json())
        .then(response => {
          console.log(cart)
          console.log(response)
          cart.querySelector('.cart-notification').classList.add('active')
        })
        .catch(err => console.error('Cart error:', err))
    })
  })
})
// Quick Add End

function handleVariantChangeFromURL() {
  const urlParams = new URLSearchParams(window.location.search)
  const variantId = urlParams.get('variant')

  if(variantId) {
    const script = document.getElementById('max-quantities')
    if (script) {
      setTimeout(() => {
        const data = JSON.parse(script.textContent)
        if (data.hasOwnProperty(variantId)) {
          document.getElementById("Quantity-Selector_Product-Page").max = data[variantId]
        }
      }, 200)
    }
    
    document.querySelectorAll('[data-variant-toggle]').forEach((item) => {
      item.style.display = "none"
      if (item.getAttribute("data-variant-toggle") == variantId) {
        item.style.display = ""
      }
    })
  }
}

// Run on initial load
handleVariantChangeFromURL()

// Listen for changes in URL (replaceState and pushState)
const originalPushState = history.pushState
const originalReplaceState = history.replaceState

history.pushState = function () {
  originalPushState.apply(this, arguments)
  handleVariantChangeFromURL()
}

history.replaceState = function () {
  originalReplaceState.apply(this, arguments)
  handleVariantChangeFromURL()
}

// Listen for back/forward navigation
window.addEventListener('popstate', handleVariantChangeFromURL)



let intervalId = null

function startInterval() {
    intervalId = setInterval(() => {
        const sellingPlanElement = document.querySelector(".shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)")?.querySelector('[data-selling-plan-id]')
        // console.log(sellingPlanElement)
        if (sellingPlanElement) {
            sellingPlanElement.checked = true
            sellingPlanElement.dispatchEvent(new Event('change', { bubbles: true }))
        }
    }, 500)
}

startInterval()

document.querySelectorAll('.product-form__input label').forEach(label => {
    label.addEventListener('click', () => {
        startInterval()
    })
})


document.addEventListener('DOMContentLoaded', function() {

  const menuDrawer = document.querySelector('#Details-menu-drawer-container')
  
  let isBodyScrollDisabled = false

  const preventBodyScroll = () => {
    isBodyScrollDisabled = true
    document.body.addEventListener('wheel', preventDefaultOnBody, { passive: false })
    document.body.addEventListener('touchmove', preventDefaultOnBody, { passive: false })
    document.body.addEventListener('keydown', preventKeyScrollOnBody, { passive: false })
  }
  
  const allowBodyScroll = () => {
    isBodyScrollDisabled = false
    document.body.removeEventListener('wheel', preventDefaultOnBody, { passive: false })
    document.body.removeEventListener('touchmove', preventDefaultOnBody, { passive: false })
    document.body.removeEventListener('keydown', preventKeyScrollOnBody, { passive: false })
  }
  
  const preventDefaultOnBody = (event) => {
    if (isBodyScrollDisabled && event.target === document.body) {
      event.preventDefault()
    }
  }
  
  const preventKeyScrollOnBody = (event) => {
    const keys = ['ArrowUp', 'ArrowDown', 'Space', 'PageUp', 'PageDown']
    if (isBodyScrollDisabled && keys.includes(event.key)) {
      event.preventDefault()
    }
  }
  
  document.querySelector('#Details-menu-drawer-container').addEventListener('click', () => {
    setTimeout(() => {
      const menuDrawer = document.querySelector('#Details-menu-drawer-container')
      if (menuDrawer.hasAttribute('open')) {
        preventBodyScroll()
      } else {
        allowBodyScroll()
      }
    }, 500)
  })




  
  const searchInputs = document.querySelectorAll('.search__input');

  document.querySelector('.header__inline-menu .header__search').addEventListener("click", () => {
    if(document.querySelector('.header__inline-menu .desktop-menu-opened').classList.contains('opened'))
    {
      document.querySelector('.header__inline-menu .desktop-menu-opened').click()
      setTimeout(() => {
        const element = document.querySelector('.header__inline-menu .header__search summary')

        element.click()
      }, 100)
    }
  })

  function checkInputValue(event) {
    const input = event.target;
    if (input.value.trim() === '') {
      const closestElement = input.closest('details[open]');
      if (closestElement) {
        console.log(closestElement)
        closestElement.removeAttribute('open');
        document.body.classList.remove('overflow-hidden')
      }
    }
  }

  searchInputs.forEach(input => {
    input.addEventListener('input', checkInputValue);

    if (input.value.trim() === '') {
      const closestElement = input.closest('details[open]');
      if (closestElement) {
        closestElement.removeAttribute('open');
        document.body.classList.remove('overflow-hidden')
      }
    }
  });

  document.querySelectorAll('.close_search_mark').forEach(el => {
    el.addEventListener("click", () => {
      const closestElement = el.closest('details[open]');
      if (closestElement) {
        closestElement.removeAttribute('open');
        document.body.classList.remove('overflow-hidden')
      }
    })
  })

  // document.getElementById('closeSearch').addEventListener("click", () => {
  //   const closestElement = document.getElementById('closeSearch').closest('details[open]');
  //   if (closestElement) {
  //     closestElement.removeAttribute('open');
  //   }
  // })
});
